import type { TOC } from '@ember/component/template-only';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';
import PathologyFields from '../not-donor/pathology-fields';

export default <template>
  <div class='field'>
    <@form.AlignedFieldsRadioGroup
      @title='Créatinine du donneur'
      @propertyName='donorCreatinine'
      as |Group|
    >
      <Group.FieldRadio @label='Ne sait pas' @value='unknown' />
      <Group.FieldRadio @label='> 190 µmol/L' @value='gt_190' />
      <Group.FieldRadio @label='<= 190 µmol/L' @value='lte_190' />
    </@form.AlignedFieldsRadioGroup>
  </div>

  <div class='field'>
    <@form.NumberInput
      @labelName='Créatinine 3 mois après la greffe (µmol/L)'
      @propertyName='creatinineThreeMonthsAfterTransplant'
      @min='20'
      @max='2000'
    />
  </div>

  <div class='field'>
    <@form.NumberInput
      @castToNumber={{true}}
      @labelName='Nombre de rejets la première année'
      @propertyName='rejectsFirstYear'
    />
  </div>

  <div class='field'>
    <@form.BasicRadioGroup
      @title='Statut CMV (cytomégalovirus)'
      @propertyName='cytomegalovirusStatus'
      as |Group|
    >
      <div class='four unstackable fields'>
        <div class='field'>
          <Group.Radio @label='D+ / R+' @value='d_plus_r_plus' />
        </div>
        <div class='field'>
          <Group.Radio @label='D+ / R-' @value='d_plus_r_minus' />
        </div>
        <div class='field'>
          <Group.Radio @label='D- / R-' @value='d_minus_r_minus' />
        </div>
        <div class='field'>
          <Group.Radio @label='D- / R+' @value='d_minus_r_plus' />
        </div>
      </div>
    </@form.BasicRadioGroup>
  </div>

  <PathologyFields @form={{@form}} />
</template> satisfies TOC<{
  Args: {
    form: ProviderSig['Blocks']['content'][0];
  };
}>;
